import { getCookie, setCookie } from '../../tools/cookie-helpers';

import myContentStore from '../../stores/my-content-store';

const { notifyChanged } = myContentStore;

export type MyContentItem = {
    title: string;
    type: string;
    permalink?: string;
};

/* The start page's permalink is '' but it's saved as '/'; compare on the saved form. */
const normalizePermalink = (permalink?: string) => (permalink === '' ? '/' : permalink);

export const getMyContent = () => {
    const cookieValue = getCookie('myContent');
    const decodedCookieValue = decodeURIComponent(cookieValue);
    return decodedCookieValue ? JSON.parse(decodedCookieValue) : [];
};

export const isInMyContent = (permalink?: string) => {
    if (permalink === undefined) {
        return false;
    }

    return (getMyContent() as MyContentItem[]).some((item) => item.permalink === normalizePermalink(permalink));
};

export const addMyContent = (object: MyContentItem) => {
    const myContent = (getMyContent() as MyContentItem[]) || [];
    const permalink = normalizePermalink(object.permalink);
    if (myContent.some((item) => item.permalink === permalink)) {
        return;
    }

    myContent.push({ ...object, permalink });
    const newMyContent = JSON.stringify(myContent);
    const newMyContentEncoded = encodeURIComponent(newMyContent);
    setCookie('myContent', newMyContentEncoded, 3000);
    notifyChanged();
};

export const deleteMyContentItemByPermalink = (permalink?: string) => {
    const myContent = (getMyContent() as MyContentItem[]) || [];

    if (!myContent) {
        return;
    }

    let filteredContent: MyContentItem[] = [];
    filteredContent = myContent.filter((item) => item.permalink !== normalizePermalink(permalink));

    const newMyContent = JSON.stringify(filteredContent);
    setCookie('myContent', newMyContent);
    notifyChanged();
};
